<div class="modal-roles flex flex-col h-full">
	<form action="" [formGroup]="formStatus" class="header-modal-roles flex flex-col px-7 pt-5">
		<div class="flex justify-end w-full">
			<div class="closeModal">
				<mat-icon class="close" (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
		<div class="content-header flex">
			<div class="image mb-3 mr-4">
				<div class="content-drag flex flex-col justify-center items-center relative">
					<div
						class="image w-[calc(100px)] h-[calc(100px)] border border-neutral-color-d rounded-2xl flex flex-col p-2"
					>
						<div class="idit-icon w-full flex justify-end">
							<mat-icon
								class="icon-edit material-icons-outlined cursor-pointer"
								(click)="editIcon()"
								>edit</mat-icon
							>
							<app-popover-status
								(iconSelected)="iconSelected($event)"
								*ngIf="isSelectIcon"
							></app-popover-status>
						</div>
						<div class="img flex justify-center items-center">
							<img [src]="icon.url" style="width: 72px; height: 72px" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="flex-col">
				<div class="flex items-center">
					<input
						class="name border border-neutral-color-d input-app"
						[placeholder]="translateModal.name"
						type="text"
						formControlName="name"
					/>
					<input
						class="ml-5 border border-neutral-color-d input-app"
						formControlName="color"
						type="color"
						name=""
						id=""
					/>
				</div>
				<div class="flex justify-between py-2.5">
					<textarea
						class="input-app text-area border border-neutral-color-d"
						[placeholder]="translateModal.description"
						formControlName="description"
					></textarea>
				</div>
			</div>
		</div>
	</form>
	<div class="body-modal flex h-full">
		<!-- List roles -->
		<div class="content-roles flex flex-col p-6">
			<div class="title">
				<span> {{ translateModal.roles }} </span>
			</div>
			<div *ngIf="!loadingRoles" class="roles-selected pt-3 border-b border-neutral-color-d pb-2 overflow-y-auto">
				<div
					class="add-role flex justify-between items-center pb-1 pt-2"
					*ngFor="let roleSelected of rolesSelected"
				>
					<div class="content-role">
						<div class="title-role">
							<span class="text-roles"> {{ roleSelected.name }} </span>
						</div>
					</div>
					<div class="add">
						<mat-icon
							class="cursor-pointer text-primary-color text-lg add"
							(click)="deleteRole(roleSelected)"
							>delete</mat-icon
						>
					</div>
				</div>
			</div>
			<app-loading-spinner *ngIf="loadingRoles" class="roles-selected"></app-loading-spinner>
			<div class="result border-t-neutral-color-c flex justify-between items-center pt-4">
				<span class="text-total"> Total </span>
				<span class="text-total">
					{{ rolesSelected.length }}
				</span>
			</div>
		</div>

		<!-- Roles -->
		<div class="add-roles h-full flex flex-col items-center px-6 pt-6 pb-4">
			<div class="search-roles w-full pb-3 flex gap-3 items-center">
				<input
					type="text"
					class="search text-neutral-color-b w-full h-10 rounded-xl pl-3 text-base font-lato outline-none"
					[placeholder]="translateModal.search"
					[(ngModel)]="search"
					[ngModelOptions]="{ standalone: true }"
				/>
				<mat-icon class="cursor-pointer text-neutral-color-e" (click)="searchRole()"
					>search</mat-icon
				>
			</div>
			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
			<div
				*ngIf="!loading"
				class="roles w-full rounded-md p-4 overflow-y-auto overflow-x-hidden"
				infiniteScroll
				[infiniteScrollDistance]="2"
				[infiniteScrollThrottle]="50"
				[infiniteScrollContainer]="selector"
				[fromRoot]="true"
				(scrolled)="onScroll()"
			>
				<div
					class="add-role flex justify-between items-center border-b border-neutral-color-d pb-1 pt-2"
					*ngFor="let role of roles"
				>
					<div class="content-role">
						<div class="title-role" [title]="role.name">
							<span class="text-roles"> {{ role.name }} </span>
						</div>
					</div>
					<div class="add">
						<mat-icon class="cursor-pointer text-primary-color text-lg add" (click)="addRole(role)"
							>add</mat-icon
						>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-modal">
		<button (click)="onNoClick()" class="mg-button secundaryButton mr-3">
			{{ translateModal.buttonCancel }}
		</button>
		<button
			[disabled]="formStatus.invalid || rolesSelected.length === 0"
			class="mg-button primaryButton"
			(click)="save()"
		>
			{{ translateModal.buttonSave }}
		</button>
	</div>
</div>
